import { useAppSelector } from "../store/hooks";

/**
 * Hook to check if a specific feature is enabled for the current user
 * @param featureName - Name of the feature to check (e.g., 'newsletter', 'usage')
 * @returns boolean indicating if the feature is enabled
 */
export function useFeatureFlag(featureName: string): boolean {
  const { profile } = useAppSelector((state) => state.user);

  if (!profile || !profile.enabled_features) {
    return false;
  }

  return profile.enabled_features[featureName] === true;
}

/**
 * Hook to check multiple features at once
 * @param featureNames - Array of feature names to check
 * @returns Object with feature names as keys and enabled status as values
 */
export function useFeatureFlags(featureNames: string[]): Record<string, boolean> {
  const { profile } = useAppSelector((state) => state.user);

  const flags: Record<string, boolean> = {};

  featureNames.forEach((featureName) => {
    flags[featureName] = profile?.enabled_features?.[featureName] === true;
  });

  return flags;
}
